import React from 'react';

import { Link } from '~/lib/react-router-dom';

import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Breadcrumbs, Typography } from '@mui/material';

function BreadcrumbLink({ href, children }: { href: string; children: React.ReactNode }) {
  return (
    <Link to={href} style={{ textDecoration: 'none' }}>
      <Typography color="primary" sx={{ '&:hover': { textDecoration: 'underline' } }}>
        {children}
      </Typography>
    </Link>
  );
}

interface Props {
  /** The current page name, displayed as the final (unlinked) breadcrumb. Omit on the campaigns list itself. */
  currentPage?: string;
}

/**
 * Deterministic breadcrumb trail for the Campaigns screens: Properties > Campaigns > [current page].
 * Replaces PageHeader's single `backButton` link so every level always resolves to a fixed route,
 * rather than relying on browser history which can land somewhere other than the campaign list.
 */
export default function CampaignBreadcrumbs({ currentPage }: Props) {
  return (
    <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} sx={{ mt: '10px', mb: 1 }}>
      <BreadcrumbLink href="/accommodation/properties">Properties</BreadcrumbLink>
      {currentPage ? (
        <BreadcrumbLink href="/accommodation/campaigns">Campaigns</BreadcrumbLink>
      ) : (
        <Typography color="text.primary" fontWeight={500}>
          Campaigns
        </Typography>
      )}
      {currentPage && (
        <Typography color="text.primary" fontWeight={500}>
          {currentPage}
        </Typography>
      )}
    </Breadcrumbs>
  );
}
